import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import EmaDestinationModal from './EmaDestinationModal';

import CreateNewChart from '../../components/modal/CreateNewChart';
import CreateNewChartLegacy from '../../components/modal/CreateNewChart.legacy';
import { triggerAutoUpload, triggerAutoUploadAndTaskCreation, refreshCurrentRecords } from '../../actions/records';
import { getDocumentCategories, getPayerNames, getEmaPatients, getTebraPatients, getEmaTaskProviders, getKareoTaskProviders, getTaskTemplatesByQuery, getMarketingRepresentatives } from '../../actions/userProfile';
import { hasFeatureInLocalStorage } from '../../global/featureFlags';

class CreateNewChartDialog extends Component {
  render() {
    // Short-lived rollout flag: render the redesigned Create-New-Chart modal when
    // the org has it enabled, otherwise the pre-redesign (legacy) one.
    //
    // Hard-gated to EMA: the redesigned patient-match flow is only fully correct for
    // EMA today — the Tebra/Kareo bound-chart upload-and-task path isn't wired yet
    // (see the chart-identity note in fileToExistingChart). Non-EMA orgs keep the
    // legacy modal even with the flag on, so the broken path is unreachable in prod.
    const redesignEnabled = hasFeatureInLocalStorage('redesigned_ema_api_chart_modals')
      && localStorage.getItem('m8_auto_upload_emr') === 'EMA';
    const ChartModal = redesignEnabled ? CreateNewChart : CreateNewChartLegacy;
    // eslint-disable-next-line react/jsx-props-no-spreading
    if (redesignEnabled) return <EmaDestinationModal {...this.props} ModalComponent={ChartModal} />;
    return (
      <div>
        <ChartModal
          {...this.props}
        />
      </div>
    );
  }
}

export default connect(state => ({
  fileName: state.auth.data.fileName,
  sendToken: state.auth.data.sendToken,
  apiPatients: state.userProfile.apiPatients,
  apiError: state.userProfile.apiError,
  apiErrorMessage: state.userProfile.apiErrorMessage,
}), {
  triggerAutoUpload,
  triggerAutoUploadAndTaskCreation,
  getDocumentCategories,
  getPayerNames,
  getEmaPatients,
  getTebraPatients,
  getEmaTaskProviders,
  getKareoTaskProviders,
  getTaskTemplatesByQuery,
  getMarketingRepresentatives,
  refreshCurrentRecords,
})(CreateNewChartDialog);
